import { IconButton, SvgNotes } from '@loomhq/lens';
import React from 'react';

import { STORE_FILLER_WORD_RANGES } from 'constants/featureFlag';
import { REVIEW_TRANSCRIPT, TRANSCRIPT } from 'constants/menuOptions';

import { useFlagIsActivated } from 'hooks/featureFlag';

const TranscriptIconButton = ({
  shouldDisableTranscript,
  handleToggleTranscriptCreator,
  currentUserIsOwner,
}: {
  shouldDisableTranscript: boolean;
  handleToggleTranscriptCreator: () => void;
  currentUserIsOwner: boolean;
}): JSX.Element => {
  const shouldShowFillerWordRemoval = useFlagIsActivated({
    flag: STORE_FILLER_WORD_RANGES,
    activationValues: [true],
  });

  return (
    <IconButton
      altText={
        shouldShowFillerWordRemoval && currentUserIsOwner
          ? REVIEW_TRANSCRIPT
          : TRANSCRIPT
      }
      icon={<SvgNotes />}
      onClick={() => handleToggleTranscriptCreator()}
      isDisabled={shouldDisableTranscript}
    />
  );
};

export default TranscriptIconButton;
